import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelText as _vModelText, withCtx as _withCtx, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "card mb-5 mb-xl-10" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"row mb-6 mt-6\" style=\"padding-left:30px;\"><h3 class=\"fw-bolder m-0\"><span class=\"card-label fw-bolder fs-3 mb-1\">Dokumen Hardcopy</span></h3><h3 class=\"fw-bolder m-0\"><span class=\"text-muted mt-1 fw-bold fs-7\">Manajemen Data Sekolah </span></h3></div>", 1)
const _hoisted_4 = {
  id: "kt_account_profile_details",
  class: "collapse show"
}
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex",
  style: {"margin-top":"5px"}
}, [
  /*#__PURE__*/_createElementVNode("label", { style: {"width":"23%","font-size":"15px","font-weight":"800"} }, "Update Detail Dokumen"),
  /*#__PURE__*/_createElementVNode("hr", { style: {"width":"77%"} })
], -1)
const _hoisted_7 = { style: {"margin-bottom":"10px"} }
const _hoisted_8 = { class: "col-12 fv-row d-flex justify-content-end" }
const _hoisted_9 = {
  class: "table-responsive",
  style: {"padding-left":"15px"}
}
const _hoisted_10 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"55%","padding-left":"15px !important"},
      class: "text-center"
    }, " Status "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"25%"},
      class: "text-center"
    }, "Tanggal"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"20%"},
      class: "text-center"
    }, "Aksi")
  ])
], -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  style: {"padding-left":"15px !important"},
  class: "text-center"
}
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/edit.svg",
  alt: ""
}, null, -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "6",
    style: {"text-align":"center"}
  }, " Tidak Ada Data ")
], -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = {
  class: "row mt-5 mb-5",
  style: {"padding-left":"15px"}
}
const _hoisted_23 = { class: "col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start" }
const _hoisted_24 = {
  class: "dataTables_length",
  id: "kt_customers_table_length"
}
const _hoisted_25 = ["label", "value"]
const _hoisted_26 = { class: "p-3" }
const _hoisted_27 = { class: "col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end" }
const _hoisted_28 = { class: "pagination" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex",
  style: {"margin-top":"50px"}
}, [
  /*#__PURE__*/_createElementVNode("label", { style: {"width":"23%","font-size":"15px","font-weight":"800"} }, "Update Catatan Dokumen"),
  /*#__PURE__*/_createElementVNode("hr", { style: {"width":"77%"} })
], -1)
const _hoisted_30 = {
  class: "row",
  style: {"margin-top":"10px","padding-left":"15px"}
}
const _hoisted_31 = { class: "col-lg-12 fv-row" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 col-form-label fw-bold fs-6" }, "Catatan", -1)
const _hoisted_33 = ["disabled"]
const _hoisted_34 = {
  class: "row d-flex justify-content-end",
  style: {"margin-top":"10px"}
}
const _hoisted_35 = {
  key: 0,
  class: "col-lg-12 fv-row d-flex justify-content-end"
}
const _hoisted_36 = {
  class: "modal fade",
  tabindex: "-1",
  id: "kt_modal_detail",
  ref: "uploadModalRef"
}
const _hoisted_37 = { class: "modal-dialog" }
const _hoisted_38 = { class: "modal-content" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", {
  class: "modal-header",
  style: {"padding-top":"10px !important","padding-bottom":"5px !important"}
}, [
  /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Detail Dokumen Hardcopy"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" })
  ])
], -1)
const _hoisted_40 = {
  class: "modal-body",
  style: {"padding-top":"5px !important"}
}
const _hoisted_41 = { class: "row" }
const _hoisted_42 = { class: "col-lg-12" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label required fw-bold fs-6" }, "Status Dokumen", -1)
const _hoisted_44 = ["label", "value"]
const _hoisted_45 = { class: "col-lg-12" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 col-form-label required fw-bold fs-6" }, "Tanggal", -1)
const _hoisted_47 = { class: "modal-footer" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-light",
  "data-bs-dismiss": "modal"
}, " Batal ", -1)
const _hoisted_49 = {
  key: 0,
  class: "card-footer d-flex justify-content-end py-6 px-9"
}
const _hoisted_50 = {
  key: 1,
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_51 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Simpan ", -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Silahkan Tunggu ... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_53 = [
  _hoisted_51,
  _hoisted_52
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Form, {
          id: "kt_account_profile_details_form",
          class: "form",
          novalidate: "novalidate",
          onSubmit: _cache[12] || (_cache[12] = ($event: any) => (_ctx.saveChanges1()))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", null, [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    (_ctx.items.showaction == true)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "btn btn-success me-3",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#kt_modal_detail",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAddModal()))
                        }, " Tambah "))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("table", _hoisted_10, [
                    _hoisted_11,
                    (_ctx.items.lengtable != 0)
                      ? (_openBlock(), _createElementBlock("tbody", _hoisted_12, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.tableData, (item, index) => {
                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                              _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.getStatus(item.status)), 1),
                              _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.dateTime(item.tanggal)), 1),
                              _createElementVNode("td", _hoisted_15, [
                                (
                            item.editable != true && _ctx.items.showaction == true
                          )
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      class: "symbol symbol-35px me-2",
                                      title: "Edit",
                                      style: {"cursor":"pointer"},
                                      "data-bs-toggle": "modal",
                                      "data-bs-target": "#kt_modal_detail",
                                      onClick: ($event: any) => (
                            _ctx.showEditModal(
                              index,
                              item.id,
                              item.status,
                              item.tanggal
                            )
                          )
                                    }, _hoisted_18, 8, _hoisted_16))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("tbody", _hoisted_19, _hoisted_21))
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("label", null, [
                        _withDirectives(_createElementVNode("select", {
                          name: "kt_customers_table_length",
                          class: "form-select form-select-sm form-select-solid",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.paging.size) = $event)),
                          placeholder: "Per page",
                          onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changePageSize()))
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paging.perPageOptions, (item) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: item,
                              label: item,
                              value: item
                            }, null, 8, _hoisted_25))
                          }), 128))
                        ], 544), [
                          [_vModelSelect, _ctx.paging.size]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_26, " Showing " + _toDisplayString(_ctx.paging.from + 1) + " to " + _toDisplayString(_ctx.paging.to) + " of " + _toDisplayString(_ctx.paging.totalElements) + " entries ", 1)
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("ul", _hoisted_28, [
                      _createElementVNode("li", {
                        class: _normalizeClass(["page-item previous", { disabled: _ctx.paging.page + 1 === 1 }])
                      }, [
                        _createElementVNode("a", {
                          class: "page-link",
                          style: {"cursor":"pointer"},
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)))
                        }, " Previous ")
                      ], 2),
                      _createElementVNode("li", {
                        class: _normalizeClass(["page-item next", { disabled: _ctx.paging.page + 1 === _ctx.paging.totalPages }])
                      }, [
                        _createElementVNode("a", {
                          class: "page-link",
                          style: {"cursor":"pointer"},
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
                        }, " Next ")
                      ], 2)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_29,
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _hoisted_32,
                    _withDirectives(_createElementVNode("textarea", {
                      disabled: _ctx.items.disablenote,
                      type: "text",
                      name: "note",
                      class: "form-control form-control-lg",
                      placeholder: "Isi Note",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.editDetail.note) = $event))
                    }, null, 8, _hoisted_33), [
                      [_vModelText, _ctx.editDetail.note]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  (_ctx.items.showaction == true)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                        _createElementVNode("button", {
                          class: "btn btn-danger me-3",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$router.push('/superadmin/legal/legalitas/')))
                        }, " Batal "),
                        _createElementVNode("button", {
                          class: "btn btn-primary me-3",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.saveChangesCatatan()))
                        }, " Simpan ")
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _hoisted_39,
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("div", _hoisted_42, [
                          _hoisted_43,
                          _createVNode(_component_Field, {
                            as: "select",
                            class: "form-select form-select-lg fw-bold",
                            name: "status1",
                            modelValue: _ctx.editDetail.status,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.editDetail.status) = $event))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.listStatus, (option) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: option.value,
                                  label: option.text,
                                  value: option.value
                                }, null, 8, _hoisted_44))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_45, [
                          _hoisted_46,
                          _createVNode(_component_Field, {
                            type: "date",
                            name: "tanggaledit",
                            class: "form-control form-control-lg",
                            placeholder: "Isi Tanggal",
                            modelValue: _ctx.editDetail.date,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.editDetail.date) = $event))
                          }, null, 8, ["modelValue"])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _hoisted_48,
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-primary",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.saveModal()))
                      }, " Simpan ")
                    ])
                  ])
                ])
              ], 512)
            ]),
            (_ctx.items.submit == true)
              ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                  (_ctx.items.showaction == true)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-danger me-3",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$router.push('/superadmin/legal/legalitas/')))
                      }, " Batal "))
                    : _createCommentVNode("", true),
                  (_ctx.items.showaction == true)
                    ? (_openBlock(), _createElementBlock("button", _hoisted_50, _hoisted_53, 512))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}